import type { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

export const CourseSideMenuSkeleton = (): ReactNode => (
  <Skeleton className="h-[calc(80vh)] w-full lg:w-82.5" />
)
